import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 7.5l-4 9.5h4l6 -15l-6 5.5","key":"svg-0"}],["path",{"d":"M22 20l-7 -15l-3 7l4 5l-8 3l14 0","key":"svg-1"}]]

/**
 * IconBrandAzure
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtYXp1cmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgNy41bC00IDkuNWg0bDYgLTE1bC02IDUuNSIgLz4KICA8cGF0aCBkPSJNMjIgMjBsLTcgLTE1bC0zIDdsNCA1bC04IDNsMTQgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-azure
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandAzure = createReactComponent('outline', 'brand-azure', 'BrandAzure', __iconNode);

export default IconBrandAzure;